module.exports = __webpack_public_path__ + "static/media/check.73ab2797.svg";